import {useInitLocales} from "@app/hooks/useInitLocales";
import {BrowserRouter} from "react-router-dom";
import AppProvider from "@app/appProvider/AppProvider";
import LayoutRoot from "@view/layout/layoutRoot/LayoutRoot";
import Auth from "@containers/auth/Auth";
import React from "react";
import AuthRoutes from "@routes/AuthRoutes";
import {useReloadOnNewVersion} from "@app/hooks/useReloadOnNewVersion";

const NewVersionWatcher = (): null => {
	useReloadOnNewVersion()
	return null
}


const App = () => {
	
	useInitLocales()
	
	return (
		<BrowserRouter>
			<NewVersionWatcher/>
			<AppProvider>
				<LayoutRoot>
					<Auth>
						<AuthRoutes/>
					</Auth>
				</LayoutRoot>
			</AppProvider>
		</BrowserRouter>
	);
};

export default App;